module.exports = __webpack_public_path__ + "img/guido-mobile.97e155de.png";